// extracted by mini-css-extract-plugin
var _1 = "ChartElement_root__9d278";
var _2 = "ChartElement_tooltip__b2f6f";
export { _1 as "root", _2 as "tooltip" }
